import e from "@dialpad/dialtone-tokens/layered/themes/tokens-aegean-colors.css?inline";
//#region themes/aegean.js
var t = {
	brand: {
		css: e,
		name: "aegean"
	},
	material: { name: "jade" }
};
//#endregion
export { t as default };
